// extracted by mini-css-extract-plugin
export default {"button":"formButton_button__2I3Y+"};